<div *ngIf="attentionBanner" class="membership-value-title">
  <img class="logo" src="/assets/tyt.svg" />
  {{ attentionBanner }}
</div>
<div class="main-container">
  <tyt-offers-wizard-host></tyt-offers-wizard-host>
  <div class="right-container" [responsiveBackgroundImage]="backgroundImage">
    <div class="center-container">
      <div class="company-value-title ql-editor" [innerHTML]="offerSet.company_value_props_title | trustHtml"></div>

      <tyt-donations-goals 
        [offerSet]="offerSet"
        [period]="period"></tyt-donations-goals>

      <div *ngIf="hasFeaturedMedia" class="featured-media-container">
        <div *ngIf="media && !vod?.asset?.url" class="vod-thumbnail" [responsiveBackgroundImage]="media?.image"></div>
        <video *ngIf="vod?.asset?.url" class="vod" [hlsSource]="vod.asset.url" controls></video>
        <div *ngIf="media" class="vod-info">
          <div class="vod-title">{{ media?.title }}</div>
          <div class="vod-description">{{ media?.description }}</div>
          <div *ngIf="production != null" class="tags">
            <tyt-content-badge [type]="vod?.type" [premium]="vod?.is_premium" [unlocked]="vod?.unlock_premium"></tyt-content-badge>
            <tyt-custom-tag *ngIf="production?.date" [text]="production?.date | date: 'MMMM d'"></tyt-custom-tag>
            <tyt-custom-tag *ngIf="vod?.duration" [text]="vod?.duration | duration"></tyt-custom-tag>
            <!-- <tyt-comments-count [identifier]="spotIdForMedia(vod)"></tyt-comments-count> -->
          </div>
        </div>
      </div>
      <div class="company-value-props">
        <div class="prop" *ngFor="let props of offerSet.company_value_props">
          <div class="title">{{ props.title }}</div>
          <div class="summary">{{ props.summary }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
